import * as React from "react";
import App from './App';
import SkContentPage from './SkContentPage';
import InterestingLinks from './interestingLinks';
import { createRoot } from "react-dom/client";
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
    },
    {
        path: "sk",
        element: <SkContentPage />
    },
    {
        path: "sk/links",
        element: <InterestingLinks />,
    },
]);

createRoot(document.getElementById("root")).render(
    <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
